import { object, string, null as zNull, type infer as zInfer } from "zod/v4";

export const setBlueCherryIntegration = {
  name: "setBlueCherryIntegration" as const,
  input: object({
    apiKey: string().optional(),
    companyCode: string(),
    environmentCode: string(),
  }),
  output: zNull(),
};

export type SetBlueCherryIntegrationInput = zInfer<
  typeof setBlueCherryIntegration.input
>;
